import "./Modal.css";
import i18n from "../../languages/i18n";

const Modal = ({
  handleClose,
  show,
  children,
  onscrollHandler,
  closeTitle,
}) => {
  const showHideClassName = show ? "modal display-block" : "modal display-none";

  return (
    <div className={showHideClassName} onWheel={onscrollHandler}>
      <div className="modal-main ">
        {children}
        <button
          type="button"
          onClick={handleClose}
          className={
            i18n.language == "en" ? "btn-submit" : "btn-submit arabicText"
          }
        >
          {closeTitle}
        </button>
      </div>
    </div>
  );
};

export default Modal;
